import { useMemo, useState } from "react";
import { PublicationFilters } from "@/components/publications/PublicationFilters";
import { PublicationList } from "@/components/publications/PublicationItem";

export const Bibliography = ({ items, lang, t }) => {
  const [year, setYear] = useState("");
  const [topic, setTopic] = useState("");
  const years = useMemo(() => [...new Set(items.map((i) => i.year).filter(Boolean))].sort((a, b) => b - a), [items]);
  const usedTopics = useMemo(() => new Set(items.flatMap((i) => i.topics || [])), [items]);
  const filtered = items.filter((i) => (!year || String(i.year) === year) && (!topic || i.topics?.includes(topic)));

  return (
    <>
      {items.length > 0 && (
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-4">
          <PublicationFilters {...{ t, lang, years, usedTopics, year, topic, setYear, setTopic }} />
          <p className="text-[12px] tracking-[0.18em] uppercase text-[#7A857F]" data-testid="bibliography-count">{t.countLabel}: {filtered.length}</p>
        </div>
      )}
      {items.length > 0 && filtered.length === 0 ? (
        <p data-testid="bibliography-no-results" className="py-8 text-[13px] text-[#7A857F] italic">{t.noResults}</p>
      ) : (
        <PublicationList items={filtered} lang={lang} t={t} testId="bibliography-list" />
      )}
    </>
  );
};
